import { defineAbility } from '@casl/ability';

import { permissions } from './permissions';

export const defineAbilityFor = (roles: string[]) =>
  defineAbility(can => {
    const userPermissions = permissions.filter(({ role }) => roles.includes(role));
    userPermissions.map(({ action, subject }) => can(action, subject));
  });
